import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CLIENT_APPRECIATION } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getClientAppreciationList = async (data = {}) => {
  try {
    const url = data?._Id
      ? `${CLIENT_APPRECIATION.GET_CLIENT_APPRECIATION_LIST}/${data?._Id}`
      : `${CLIENT_APPRECIATION.GET_CLIENT_APPRECIATION_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addClientAppreciation = async (data = {}) => {
  try {
    const response = await POST(CLIENT_APPRECIATION.ADD_CLIENT_APPRECIATION, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateClientAppreciation = async (id, data = {}) => {
  try {
    const url = `${CLIENT_APPRECIATION.ADD_CLIENT_APPRECIATION}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientAppreciationDataById = async (data = {}) => {
  try {
    const url = data?.Id
      ? `${CLIENT_APPRECIATION.GET_CLIENT_APPRECIATION_LIST}/${data?.Id}`
      : `${CLIENT_APPRECIATION.GET_CLIENT_APPRECIATION_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchClientAppreciationTableAndFilterSchema = async (data = {}) => {
  try {
    const url = data?._Id
      ? `${CLIENT_APPRECIATION.GET_CLIENT_APPRECIATION_SCHEMA}/${data?._Id}`
      : `${CLIENT_APPRECIATION.GET_CLIENT_APPRECIATION_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientAppreciationFilterData = async (data = {}) => {
  try {
    const response = await POST(CLIENT_APPRECIATION.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
